<template>
  <div
    class="position-relative"
    @mouseenter="showDelete = true"
    @mouseleave="showDelete = false"
  >
    <v-icon
      v-if="showDelete && !disabled"
      class="delete-avatar-icon"
      size="12"
      color="blue-grey"
      @click="$emit('remove', account)"
      >mdi-close-circle</v-icon
    >
    <UserAvatar v-bind="$props" />
  </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue'
export default {
  name: 'AccountAvatar',

  components: {
    UserAvatar,
  },

  props: {
    disabled: Boolean,
    account: Object,
    size: String,
    fontSize: String,
  },

  data() {
    return { showDelete: false }
  },
}
</script>

<style scoped lang="scss">
.delete-avatar-icon {
  cursor: pointer;
  background-color: $color-white;
  border-radius: 10px;
  position: absolute;
  height: 10px;
  width: 10px;
  top: 0;
  right: 0;
  z-index: 1;
}
.position-relative {
  position: relative;
}
</style>
